module.exports = __webpack_public_path__ + "static/login-567fc901160494ea84a8360da384475d.mp4";